export default __webpack_public_path__ + "static/media/2017 DEC ZURY PASSION-06.dcb2d0da.jpg";